module.exports = __webpack_public_path__ + "img/map1.3228e6a6.jpg";